module.exports = __webpack_public_path__ + "img/2.9651a09b.jpg";